import { createSelector } from 'reselect';

export const currentRouteSelector = state => state.Router.currentRoute;

export const routeParamsSelector = createSelector(currentRouteSelector, ({ params }) => params);
